import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

const Privateroute = lazy(() => import('./route/privateroute'));
const Publicroute = lazy(() => import('./route/publicroute'));

const Panellayout = lazy(() => import('./layout/panel/panellayout'));

const Authlayout = lazy(() => import('./layout/auth/authlayout'));
const Login = lazy(() => import('./pages/login'));
const Nopage = lazy(() => import('./pages/nopage'));

const Dashboard = lazy(() => import('./pages/panel/dashboard/dashboard'));
const Pagenotfound = lazy(() => import('./pages/panel/pagenotfound/pagenotfound'));

const Candidate = lazy(() => import('./pages/panel/candidate/candidate'))
const Timesheet = lazy(() => import('./pages/panel/timesheet/timesheet'))
const Paymentadvice = lazy(() => import('./pages/panel/paymentadvice/paymentadvice'))
const Paymentmaster = lazy(() => import('./pages/panel/paymentadvicemaster/paymentmaster'));

const OthersParser = lazy(() => import('./pages/panel/parsepdf/parserothers'));

const Clientmaster = lazy(() => import('./pages/panel/clientmaster/clientmaster'));
const BillMaster = lazy(() => import('./pages/panel/billmaster/billmaster'));
const TopayDashboard = lazy(() => import('./pages/panel/topaydashboard/topaydashboard'));
const CriticalDashboard = lazy(() => import('./pages/panel/criticaldashboard/criticaldashboard'));
const Vendormaster = lazy(() => import('./pages/panel/vendormaster/vendormaster'));
const ParsePdf = lazy(() => import('./pages/panel/parsepdf/parsepdf'));

const Canreport = lazy(() => import('./pages/panel/canreport/canreport'));
const Dummyreport = lazy(() => import('./pages/panel/canreport/dummyreport'));
const Grndetails = lazy(() => import('./pages/panel/grndetails/grndetails'));
const Dailybillreport = lazy(() => import('./pages/panel/canreport/dailybillreport'));
const Vendordetailsreport = lazy(() => import('./pages/panel/vendordetailsreport/vendordetailsreport'));
const Clientbilling = lazy(() => import('./pages/panel/clientbilling/clientbilling'));


function App() {
  return (
    <>
      <Suspense fallback={<p>Loading...</p>}>
        <Routes>

          <Route element={<Publicroute />}>
            <Route path="/" element={<Authlayout><Login /></Authlayout>} />
          </Route>

          <Route element={<Privateroute />}>
            <Route path="/panel" element={<Panellayout />}>
              <Route index element={<Dashboard />} />
              <Route path="panel" element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />

              <Route path="candidate" element={<Candidate />} />
              <Route path="timesheet" element={<Timesheet />} />
              <Route path="paymentadvice" element={<Paymentadvice />} />
              <Route path="paymentmaster" element={<Paymentmaster />} />
              <Route path="clientmaster" element={<Clientmaster />} />
              <Route path="vendormaster" element={<Vendormaster />} />
              <Route path="billmaster" element={<BillMaster />} />
              <Route path="clientbilling" element={<Clientbilling />} />
              <Route path="topaydashboard" element={<TopayDashboard/>} />
              <Route path="criticaldashboard" element={<CriticalDashboard/>} />
              <Route path="parsepdf" element={<ParsePdf />} />
              <Route path="parserothers" element={<OthersParser />} />
              <Route path="*" element={<Pagenotfound />} />
              <Route path="canreport" element={<Canreport /> } />
              <Route path="dummyreport" element={<Dummyreport /> } />
              <Route path="grndetails" element={<Grndetails /> } />
              <Route path="dailybillreport" element={<Dailybillreport />} />
              <Route path="vendordetailsreport" element={<Vendordetailsreport />} />
            </Route>
          </Route>

          <Route path="*" element={<Authlayout><Nopage /></Authlayout>} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
